import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentSectionPreference, DwComponentType, DwSectionBaseComponent } from '@devwareapps/devware-cap';

@DwComponent({
  name: 'MOR Employee Type Reset',
  key: 'EmployeeTypeReset',
  parentItemName: 'MemoOfRecord',
  componentType: DwComponentType.formSection,
})

@Component({
  selector: 'app-employee-type-reset',
  templateUrl: './employee-type-reset.component.html',
  styleUrls: ['./employee-type-reset.component.scss']
})
export class EmployeeTypeResetComponent extends DwSectionBaseComponent<DwComponentSectionPreference> implements OnInit{

  setupComponentComplete(): void {
    this.formGroup.get('EmployeeTypeCv').valueChanges
      .subscribe(value => {
        this.formGroup.get('EmployeeEthos_UserId').setValue(null);
        this.formGroup.get('Ethos_SubcontractorBranchId').setValue(null);
        this.formGroup.get('EmployeeName').setValue(null);
      });
    }
}
